import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { TooltipProvider } from "./components/ui/primitives/tooltip";
import "./components/ui/theme.css";
import "./styles.css";
import "./components/StudioWorkbench.css";
import "./components/StudioTheme.css";
import "./components/ui/components.css";
async function start() {
  try {
    const response = await fetch("/api/v1/ready", {
      signal: AbortSignal.timeout(5000),
    });
    const policy = response.ok ? await response.json() : undefined;
    // A database reset applies to server-disk media and cloud media equally.
    if (policy?.data_epoch) {
      const keep = new Set(["aclip-script-view", "aclip-asset-view"]);
      for (const storage of [localStorage, sessionStorage]) {
        if (storage.getItem("aclip-data-epoch") === policy.data_epoch) continue;
        for (const key of Object.keys(storage)) {
          if (key.startsWith("aclip-") && !keep.has(key))
            storage.removeItem(key);
        }
        storage.setItem("aclip-data-epoch", policy.data_epoch);
      }
    }
  } catch {
    // Offline startup must still show the workspace's normal connection feedback.
  }
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <TooltipProvider delayDuration={350}>
        <App />
      </TooltipProvider>
    </React.StrictMode>,
  );
}
void start();
